<template>
  <div class="cookies-bar" v-if="showCookieBar">
    <div class="md-offset">
      <div class="c-content">
        Witryna używa plików cookies. Korzystając z niej, zgadzasz się na
        wykorzystywanie cookies zgodnie z aktualnymi ustawieniami przeglądarki,
        z której korzystasz. Szczegółowe informacje znajdziesz w naszej
        <a :href="policyUrl">Polityce prywatności</a>
      </div>
      <button @click="setCookie" class="md-button md-info">Ok</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CookiesBar',
  data() {
    return {
      showCookieBar: false,
    }
  },
  created() {
    if (this.getCookie()) {
      this.showCookieBar = false
    } else {
      this.showCookieBar = true
    }
  },
  computed: {
    ...mapState({
      policyUrl: state => state.policyDocUrl,
    }),
    showCookiear() {
      if (this.getCookie()) {
        return false
      } else {
        return true
      }
    },
  },
  methods: {
    setCookie(exdays = 7) {
      let d = new Date()
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      let expires = 'expires=' + d.toUTCString()
      document.cookie = 'tplCookieConsent' + '=' + 1 + ';' + expires + ';path=/'
      this.showCookieBar = false
    },
    getCookie(cname = 'tplCookieConsent') {
      let name = cname + '='
      let ca = document.cookie.split(';')
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    },
  },
}
</script>

<style scoped lang="scss">
.cookies-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  background-color: #fff;
  box-shadow: 0 3px 33px rgba(0, 0, 0, 0.08);
  padding: 10px 0;
  a {
    text-decoration: none;
  }
  .md-button {
    font-size: 13px;
    padding: 10px 20px 9px;
  }
  .md-offset {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 576px) {
      padding: 0 10px;
    }
  }
  .c-content {
    font-size: 14px;
    padding-right: 10px;
    line-height: 1.3em;
    @media screen and (max-width: 768px) {
      font-size: 10px;
    }
  }
}
</style>
